import { observer } from 'mobx-react'
import React from 'react'
import styles from './OCRScopeJobDetailBodyTitle.sass'

interface OCRScopeJobDetailBodyTitleProps {
  title: string
}
export default observer(function OCRScopeJobDetailBodyTitle({
  title,
}: OCRScopeJobDetailBodyTitleProps) {
  return <div className={styles.root}>{title}</div>
})
